import { __extends } from "tslib";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { connect } from "react-redux";
import { ButtonWithIcon } from "../ButtonWithIcon";
import { IFilter } from "../../models/filter";
import { IDimension } from "../../models/node";
import { ITranslations } from "../../models/translations";
import { addFilter, changeFilterInput, generateReportRequest, IChangeFilterInput, ISelectFilter, removeFilter, selectFilterOption, } from "../../state/actions";
import { IReportBuilderState } from "../../state/reducers";
import { FilterControl } from "./FilterControl";
var FilterControls = (function (_super) {
    __extends(FilterControls, _super);
    function FilterControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilterControls.prototype.render = function () {
        var _a = this.props, filters = _a.filters, dimensions = _a.dimensions, onFilterOptionSelected = _a.onFilterOptionSelected, onFilterInputChanged = _a.onFilterInputChanged, onFilterAddClicked = _a.onFilterAddClicked, onFilterRemoveClicked = _a.onFilterRemoveClicked, onGenerateReportRequest = _a.onGenerateReportRequest, t = _a.t;
        return (React.createElement("div", { className: "rb-report-filters" },
            React.createElement("div", { className: "rb-title-dark rb-title-extra-small" },
                t.filtersText,
                " ",
                React.createElement("span", null,
                    "- ",
                    t.optionalLabel)),
            filters && (React.createElement("div", { className: "rb-filter-container" },
                filters.map(function (filter, index) { return (React.createElement(FilterControl, { key: index, filter: filter, dimensions: dimensions, onFilterRemoveClicked: onFilterRemoveClicked, onFilterOptionSelected: onFilterOptionSelected, onFilterInputChanged: onFilterInputChanged, onGenerateReportRequest: onGenerateReportRequest, t: t })); }),
                React.createElement("div", { className: "rb-btn-container rb-fill-parent", style: { marginBottom: 0 } },
                    React.createElement(ButtonWithIcon, { title: t.addFilterButton, styleClasses: "btn rb-btn-small rb-btn-red rb-fill-parent", icon: faPlusCircle, onClick: onFilterAddClicked }))))));
    };
    return FilterControls;
}(React.PureComponent));
var connected = connect(function (state) {
    var filters = state.filters, dimensions = state.dimensions, translations = state.translations;
    return {
        filters: filters,
        dimensions: dimensions && dimensions.data,
        t: translations,
    };
}, function (dispatch) {
    return {
        onFilterAddClicked: function () { return dispatch(addFilter()); },
        onFilterOptionSelected: function (payload) {
            return dispatch(selectFilterOption(payload));
        },
        onFilterInputChanged: function (payload) {
            return dispatch(changeFilterInput(payload));
        },
        onFilterRemoveClicked: function (payload) {
            return dispatch(removeFilter(payload));
        },
        onGenerateReportRequest: function () { return dispatch(generateReportRequest()); },
    };
})(FilterControls);
export { connected as FilterControls };
